import * as React from 'react';

interface ToolIconRadioButtonSetProps {
  style?: React.CSSProperties;
}

const fundamentalStyle: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
};

const ToolIconRadioButtonSet: React.SFC<ToolIconRadioButtonSetProps> = (props) => {
  const children = (
    props.children as React.ReactElement<any>[]
  ).map((elm, index) => {
    return React.cloneElement(elm, { index, key: `radiobutton-${index}` });
  });

  return (
    <div style={{ ...fundamentalStyle, ...props.style }}>
      {children}
    </div>
  );
};

export default ToolIconRadioButtonSet;
